import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { EnumValue } from '@/core/models/enumvalue.model';
import { StateService } from '@/core/services/state.service';
import { GlobalEnumsAceRechtsform } from '@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-rechtsform';
import { InstitutionDisplayModelFormGroup } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/institution-display-model';
import { I18nService } from '@/core/services/i18nService';

@Component({
  selector: 'institution',
  templateUrl: './institution.component.html',
  styleUrls: ['./institution.component.scss']
})
export class InstitutionComponent implements OnInit {
  @Input("form") public institutionForm: InstitutionDisplayModelFormGroup;

  @Input()
  public set disabled(value: boolean) {
    if (value)
      this.institutionForm.disable()
  }

  public get isDisabled(): boolean {
    return this.institutionForm.disabled;
  }

  public get rechtsformList(): EnumValue[] {
    let rechtsformList = GlobalEnumsAceRechtsform.getAsDataset();
    rechtsformList.forEach((rechtsform: EnumValue) => rechtsform.Description = this.translateservice.instant("Enum.GlobalEnumsAceRechtsform." + rechtsform.Name));
    return rechtsformList;
  }

  constructor(protected stateService: StateService, protected translateservice: I18nService) { }

  public ngOnInit(): void {
    if (this.stateService.IsEndvalidationEnabled) {
      this.institutionForm.Name.addValidators(Validators.required);
      this.institutionForm.Rechtsform.addValidators(Validators.required);
      this.institutionForm.markAllAsTouched();
    }
  }
}
